import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [showInstall, setShowInstall] = useState(false);

  useEffect(() => {
    const sync = () => {
      const standalone =
        window.matchMedia?.('(display-mode: standalone)')?.matches === true ||
        window.navigator?.standalone === true;
      const dp = window.__vexi_deferredPrompt;
      setShowInstall(Boolean(dp) && !standalone);
    };
    sync();
    window.addEventListener('vexi:install-ready', sync);
    window.addEventListener('appinstalled', sync);
    return () => {
      window.removeEventListener('vexi:install-ready', sync);
      window.removeEventListener('appinstalled', sync);
    };
  }, []);

  const handleInstall = async () => {
    const dp = window.__vexi_deferredPrompt;
    if (!dp?.prompt) return;
    try {
      await dp.prompt();
      await dp.userChoice;
    } finally {
      window.__vexi_deferredPrompt = null;
      setShowInstall(false);
      window.dispatchEvent(new Event('vexi:install-ready'));
    }
  };

  return (
    <footer className="border-t border-border bg-card/30">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col items-center gap-3">
          <div className="text-xs text-muted-foreground text-center">
            Free to use. Powered by the community.
          </div>

          <nav className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-sm text-center">
            <Link to="/privacy" className="text-muted-foreground hover:text-foreground hover:underline">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-muted-foreground hover:text-foreground hover:underline">
              Terms
            </Link>
            <Link
              to="/community-guidelines"
              className="text-muted-foreground hover:text-foreground hover:underline"
            >
              Community Guidelines
            </Link>
            <Link
              to="/report-issue"
              className="text-muted-foreground hover:text-foreground hover:underline"
            >
              Report an Issue
            </Link>
            <Link to="/partner" className="text-muted-foreground hover:text-foreground hover:underline">
              Partner
            </Link>
            <a
              href="mailto:support@vexi.co.za"
              className="text-muted-foreground hover:text-foreground hover:underline"
            >
              Contact / Feedback
            </a>
            {showInstall && (
              <button
                type="button"
                data-testid="footer-install-app"
                onClick={handleInstall}
                className="text-muted-foreground hover:text-foreground hover:underline"
              >
                Install app
              </button>
            )}
          </nav>
        </div>
      </div>
    </footer>
  );
}

